import Box from "@mui/material/Box";


const AboutUsPage = () => {
    return (
        <Box>
            &laque;AboutUsPage&raque;
            &laque;
        </Box>
    );
}

export default AboutUsPage;
